import React, { useState, useContext } from 'react';
import { Divider, Typography } from '@common-ui/ui';
import CreateNewReport from '../../components/CreateNewReport';
import AddToReport from '../../components/AddToReport';
import { ModalContext } from '../..';

/**
 * This is the modal for creating a report or adding to a report from the Image Editor screen
 * It will show the CreateNewReport component if the open state is CreateNewReport
 * It will show the AddToReport component if the open state is AddToReport
 *
 * @param {Array} selectedImageIds - The selected image ids to be added to a report
 * @returns {JSX.Element} - The modal
 *
 */
export default function Report({ selectedImageIds }) {
  // This is the modal context that will be used to get the title of the modal
  const { modal } = useContext(ModalContext);

  // By default, the modal will show the CreateNewReport component
  const [open, setOpen] = useState('CreateNewReport');
  return (
    <div style={container}>
      <div style={title}>
        <Typography align="center" variant="h5">
          {modal.title}
        </Typography>
        <Divider />
      </div>
      <div style={accordions}>
        <CreateNewReport open={open} setOpen={setOpen} selectedImageIds={selectedImageIds} />
        <Divider>OR</Divider>
        <AddToReport open={open} setOpen={setOpen} selectedImageIds={selectedImageIds} />
      </div>
    </div>
  );
}

const container = {
  width: '554px',
  height: '575px',
  opacity: 1,
  padding: '24px',
};

const title = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: '12px',
};

const accordions = {
  borderTop: '1px solid rgba(255, 255, 255, 0.12)',
  borderBottom: '1px solid rgba(255, 255, 255, 0.12)',
};
